import gsap from 'gsap';

export class MarqueeService {
  constructor() {
    this.initHomepage();
  }

  initHomepage(): void {
    const marqueeRow1: HTMLElement | null = document.getElementById('row1');
    const marqueeRow1Clone: HTMLElement | null = document.getElementById('row1-clone');
    const marqueeRow2: HTMLElement | null = document.getElementById('row2');
    const marqueeRow2Clone: HTMLElement | null = document.getElementById('row2-clone');

    if (!marqueeRow1 || !marqueeRow1Clone || !marqueeRow2 || !marqueeRow2Clone) {
      return;
    }

    const row1Container: HTMLElement | null = marqueeRow1.parentElement;
    const row2Container: HTMLElement | null = marqueeRow2.parentElement;

    if (!row1Container || !row2Container) {
      return;
    }

    this.#adjustFontSize(marqueeRow1, marqueeRow1Clone);
    this.#adjustFontSize(marqueeRow2, marqueeRow2Clone);

    this.#createMarquee(row1Container, 'left');
    this.#createMarquee(row2Container, 'right');

    window.addEventListener('resize', (): void => {
      this.#adjustFontSize(marqueeRow1, marqueeRow1Clone);
      this.#adjustFontSize(marqueeRow2, marqueeRow2Clone);
      this.#createMarquee(row1Container, 'left');
      this.#createMarquee(row2Container, 'right');
    });
  }

  #adjustFontSize(element: HTMLElement, clone: HTMLElement): void {
    const containerWidth: number = window.innerWidth;
    let fontSize = 100;

    element.style.fontSize = fontSize.toString() + 'px';
    clone.style.fontSize = fontSize.toString() + 'px';

    while (element.offsetWidth < containerWidth && fontSize < 1000) {
      fontSize += 10;
      element.style.fontSize = fontSize.toString() + 'px';
      clone.style.fontSize = fontSize.toString() + 'px';
    }

    while (element.offsetWidth > containerWidth && fontSize > 10) {
      fontSize -= 1;
      element.style.fontSize = fontSize.toString() + 'px';
      clone.style.fontSize = fontSize.toString() + 'px';
    }
  }

  #createMarquee(container: HTMLElement, direction: string): void {
    const firstChild = container.firstElementChild as HTMLElement;
    const elementWidth: number = firstChild.offsetWidth;

    gsap.killTweensOf(container);

    const speed = 40;
    const duration: number = elementWidth / speed;

    if (direction === 'left') {
      gsap.set(container, { x: 0 });
      gsap.to(container, {
        x: -elementWidth,
        duration: duration,
        ease: 'none',
        repeat: -1,
        modifiers: {
          x: gsap.utils.unitize((x: number): number => {
            if (x <= -elementWidth) {
              x %= -elementWidth;
            }
            return x;
          }),
        },
      });
    } else {
      gsap.set(container, { x: -elementWidth });
      gsap.to(container, {
        x: 0,
        duration: duration,
        ease: 'none',
        repeat: -1,
        modifiers: {
          x: gsap.utils.unitize((x: number): number => {
            if (x >= 0) {
              x = (x % elementWidth) - elementWidth;
            }
            return x;
          }),
        },
      });
    }
  }
}
